import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

export const BankIdentityVerificationChip = () => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      label={t(
        Resources.Pages.Content.BankAccounts.BankIdentityVerificationAccount,
      )}
      variant="outlined"
      size="small"
    />
  );
};
